import classNames from 'classnames';

import { OptionVariationData } from '../../../../data/model';
import { FabricFacetFiltersTranslation } from '../../../../localization/SiteTranslation';
import SelectedFilters from '../../../../shared/FilterState/SelectedFilters';
import FabricFacetFiltersState from '../FabricFacetFiltersState';
import ColorFacetFilter from './ColorFacetFilter/ColorFacetFilter';
import ColorFacetFilterState from './ColorFacetFilter/ColorFacetFilterState';
import css from './FabricFacetFiltersDropdowns.css';
import FacetFilter from './FacetFilter/FacetFilter';

interface FabricFacetFiltersDropdownsProps {
  state: FabricFacetFiltersState;
  total: number;
  translation: FabricFacetFiltersTranslation;
  allItems: Array<OptionVariationData>;
  className?: string;
}

const FabricFacetFiltersDropdowns = ({ className, state, translation, allItems }: FabricFacetFiltersDropdownsProps) => {
  return (
    <div className={classNames(css.root, className)}>
      <div className={css.items}>
        {/* TODO: Move to a separate component */}
        {state.filters.map((s) => {
          if (s instanceof ColorFacetFilterState) {
            return <ColorFacetFilter state={s} key={s.data.name} translation={translation} allItems={allItems} />;
          }
          return <FacetFilter state={s} key={s.data.name} allItems={allItems} translation={translation} />;
        })}
      </div>
      {state.selection.properties.any() && <SelectedFilters selection={state.selection} translation={translation} />}
    </div>
  );
};

export default FabricFacetFiltersDropdowns;
